import { ContactFormData, ContactResponse, Project } from '../types/api';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

export class ContactApi {
    static async submitContact(data: ContactFormData): Promise<ContactResponse> {
        try {
            const response = await fetch(`${API_BASE_URL}/api/contact`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify(data),
            });

            // Handle HTTP errors
            if (!response.ok) {
                if (response.status >= 400 && response.status < 500) {
                    const errorData = await response.json().catch(() => ({}));
                    throw new Error(errorData.message || 'Invalid request. Please check your input.');
                } else {
                    throw new Error('Server error. Please try again later.');
                }
            }

            return await response.json();
        } catch (error) {
            // Network or parsing errors
            if (error instanceof Error) {
                throw error;
            }
            throw new Error('Failed to submit contact form. Please check your connection.');
        }
    }

    static async healthCheck(): Promise<boolean> {
        try {
            const response = await fetch(`${API_BASE_URL}/api/health`, {
                method: 'GET',
                headers: { 'Accept': 'application/json' },
            });
            return response.ok;
        } catch {
            return false;
        }
    }

    static async getProjects(): Promise<Project[]> {
        try {
            const response = await fetch(`${API_BASE_URL}/api/projects`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch projects: ${response.status}`);
            }

            return await response.json();
        } catch (error) {
            console.error('Error fetching projects:', error);
            throw new Error('Failed to load projects. Please try again later.');
        }
    }

    static async getProjectById(id: number): Promise<Project> {
        try {
            const response = await fetch(`${API_BASE_URL}/api/projects/${id}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            });

            if (!response.ok) {
                if (response.status === 404) {
                    throw new Error('Project not found');
                }
                throw new Error(`Failed to fetch project: ${response.status}`);
            }

            return await response.json();
        } catch (error) {
            console.error('Error fetching project:', error);
            throw error;
        }
    }
}
